import { transport } from 'config/transport';

export function callApiCreateStudent(classId, studentBody) {
    return transport.post(`/mamnon/classes/${classId}/students`, studentBody);
}
